<template>
    <div class="reservation-update-form">
        <a-form :form="form" layout="vertical">
            <a-form-item :label="$t('message.startDateTime')">
                <a-date-picker
                    v-decorator="['startDate', decoratorConfig]"
                    :show-time="true"
                    format="YYYY-MM-DD HH:mm"
                />
            </a-form-item>
            <a-form-item :label="$t('message.endDateTime')">
                <a-date-picker v-decorator="['endDate', decoratorConfig]" :show-time="true" format="YYYY-MM-DD HH:mm" />
            </a-form-item>
            <a-form-item :label="$t('message.summary')">
                <a-input v-decorator="['summary', decoratorConfig]" />
            </a-form-item>
            <a-form-item :label="$t('calendar.description')">
                <a-input v-decorator="['description', decoratorConfig]" />
            </a-form-item>
            <div v-for="(input, index) in formValues" :key="index">
                <a-form-item :label="input.label">
                    <a-input v-model="formValues[index].value" />
                </a-form-item>
            </div>
            <div class="buttons">
                <a-button type="primary" @click="onUpdate">{{ $t("message.update") }}</a-button>
                <a-button @click="onCancel">{{ $t("calendar.cancel") }}</a-button>
            </div>
        </a-form>
    </div>
</template>

<script>
import Vue from "vue";
import { Form, Input, Button, DatePicker, message, Modal } from "ant-design-vue";
import moment from "moment";
import { CALENDAR_API } from "../../../../api/calendar";

export default Vue.extend({
    name: "ReservationUpdateForm",
    props: {
        eventDetail: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            decoratorConfig: {
                rules: [{ required: true, message: "Bu alan gereklidir" }],
            },
            formValues: JSON.parse(JSON.stringify(this.eventDetail.formValues)), // Dinamik form değerleri
        };
    },
    methods: {
        onUpdate() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    Modal.confirm({
                        title: "Güncellemeyi onaylıyor musunuz?",
                        okText: "Evet",
                        cancelText: "Hayır",
                        onOk: () => {
                            const payload = {
                                id: this.eventDetail._id,
                                updatingFields: {
                                    startDate: values.startDate,
                                    endDate: values.endDate,
                                    summary: values.summary,
                                    description: values.description,
                                    formValues: this.formValues,
                                },
                            };
                            CALENDAR_API.updateReservationEvent(payload.id, payload.updatingFields)
                                .then((res) => {
                                    message.success("Rezervasyon başarıyla güncellendi.");
                                    this.$emit("updateCompleted", {
                                        event: res.data,
                                        updatingFields: payload.updatingFields,
                                    });
                                })
                                .catch((error) => {
                                    message.error("Güncelleme sırasında bir hata oluştu.");
                                    console.error(error);
                                });
                        },
                    });
                }
            });
        },
        onCancel() {
            this.$emit("cancelUpdate");
        },
    },
    mounted() {
        // Form alanlarını varsayılan değerlerle doldur
        this.form.setFieldsValue({
            startDate: moment(this.eventDetail.start),
            endDate: moment(this.eventDetail.end),
            summary: this.eventDetail.summary,
            description: this.eventDetail.description,
        });
    },
});
</script>

<style scoped lang="scss">
.reservation-update-form {
    .buttons {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;

        a-button {
            margin-left: 10px;
        }
    }
}
</style>
